// Which parts of the roster review screen are SERIOUS -- shown once, at the top,
// as large white text on solid red (SeriousWarning.jsx) -- and which stay in the
// ordinary finding list.
//
// Why a separate tier at all: on 2026-09-19 Marshall Elementary's roster was
// imported into Moon (Richard M.) Elementary past two red findings ("Only 0.0%
// of the returning students ... have a student ID that appears in fall2026",
// "TK ... had students last season and none in this file"). They were the same
// size and colour as every other line on the page, halfway down it, and they
// were read past. A warning that can stop an import has to look like one.
//
// Serious = an import blocker (the server will refuse to run the import without
// an explicit override) or a year-over-year finding the server graded `alert`.
// Everything else keeps its place.

export const buildSeriousWarnings = ({ blockers, comparison }) => {
  const items = (blockers || []).map((message) => ({
    key: `blocker:${message}`,
    message,
    blocking: true,
  }));

  if (comparison && comparison.available !== false) {
    (comparison.findings || [])
      .filter((finding) => finding.severity === 'alert')
      .forEach((finding) => items.push({
        key: `finding:${finding.message}`,
        message: finding.message,
        blocking: false,
      }));
  }

  return items;
};

// The year-over-year findings left for the ordinary list once the serious ones
// have moved to the top -- so no line is shown twice.
export const ordinaryFindings = (findings) => (findings || []).filter((finding) => finding.severity !== 'alert');
